import { createContext, FC, PropsWithChildren } from 'react';
import { IUserInfo } from '../users-service-types';
import { useUserInfo } from '../hooks/useUserInfo';

export const authContext = createContext<IUserInfo | undefined>(undefined);

const getStoredUserInfo = () => {
    let userInfo: IUserInfo | undefined;
    const userInfoString = localStorage.getItem('userInfo');

    if (userInfoString) {
        userInfo = JSON.parse(userInfoString);
    }

    return userInfo;
}

interface IAuthProviderProps extends PropsWithChildren {}

export const AuthProvider: FC<IAuthProviderProps> = ({ children }) => {
    const auth = useUserInfo();
    return <authContext.Provider value={auth ?  auth : getStoredUserInfo()}>{children}</authContext.Provider>;
}
